<template>
  <div class="tw-px-2 2xl:tw-px-0">
    <news-article-summary
      abstractTag="h2"
      :media="media"
      :mediaType="mediaType"
      :date="date"
      :title="title"
      :abstract="abstract"
    />
    <article
        itemprop="articleBody"
    >
      <rich-text
        :richText="text"
      />
    </article>
    <vue-button
      :square="true"
      :primary="true"
      @onClick="onClick"
      :label="ctaLabel"
      :align="ctaPosition"
      class="tw-mt-14"
    />
  </div>
</template>

<script>
import './news-article.scss';
import RichText from '@/stories/Atoms/RichText/RichText.vue';
import VueButton from "@/stories/Atoms/Button/Button.vue";
import NewsArticleSummary from "@/stories/Components/NewsArticle/Elements/NewsArticleSummary/NewsArticleSummary"

export default {
  name: 'NewsArticle',
  components: {
    NewsArticleSummary,
    RichText,
    VueButton,
   },
  props: {
    ctaLabel: {
      type: String,
      required: false
    },
    ctaPosition: {
      type: String,
      required: false
    },
    date: {
      type: String,
      required: false
    },
    abstract: {
      type: String,
      required: false
    },
    mediaType: {
      type: String,
      default: "image",
      validator(value) {
        return ["image", "video"].includes(value);
      },
      required: false
    },
    media: {
      type: Object,
      required: true
    },
    onClickCTA: {
      type: Function,
      required: false
    },
    text: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
  },
  computed: {
    isVideo() {
      return this.mediaType === "video"
    },
  },
  methods: {
    onClick() {
      this.onClickCTA();
    }
  }
}
</script>
